import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const StarFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      fill="currentColor"
    />
  </svg>
);

StarFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(StarFilledIcon);
